import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AIDecorationExperiencePluginState } from './reducer';

export const aiExperienceDecorationPluginKey = new PluginKey<AIDecorationExperiencePluginState>(
	'aiExperienceDecoration',
);
